export default __webpack_public_path__ + "static/media/View.a2d2b672.svg";